<template>
  <!-- background-color: #F4F5FA -->
  <v-app-bar
    app
    style="z-index:200;background-color: #FFFFFF;"
    flat
  >
    <!-- <v-app-bar-nav-icon class="hidden-md-and-up"  @click="drawer = !drawer" />
    <div
      style="padding-top:30px;"
    >
      <v-text-field
        placeholder="Search"
        filled
        rounded
        dense
        prepend-inner-icon="mdi-magnify"
      />
    </div> -->
    <v-app-bar-nav-icon @click="drawer = !drawer" />
    <v-toolbar-title v-show="$route.name !== 'Dashboard'" style="font-size:1rem">
      {{ $route.name }}
    </v-toolbar-title>
    
    <v-spacer />
    <span @click="redirectToAccuGene" style="cursor: pointer">
      <v-img max-width="190" :src="require('@/assets/logo_final.svg')" />
    </span>
  </v-app-bar> 
  <!-- <v-app-bar
    v-if="isMobile"
    app
    style="z-index: 200;"
    color="#F4F5FA"
    flat
  >
    <v-app-bar-nav-icon @click="drawer = !drawer" />
    <v-toolbar-title style="letter-spacing: 1px">
      {{ $route.name }}
    </v-toolbar-title>
    <v-spacer />Analysis v 1.2.0
  </v-app-bar> -->
</template>
<script>
export default {
  name: 'DefaultBar',
  data() {
    return {
      isMobile: false,
      idDark: false,
    };
  },
  computed: {
    drawer: {
      get () {
        return this.$store.getters['app/getDrawer']
      },
      set (value) {
        return this.$store.commit('app/setDrawer', value)
      }
    }
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    redirectToAccuGene() {
      window.location.href = 'https://accugenelab.com/';
    },
    checkMobile() {
      this.isMobile = this.$vuetify.breakpoint.xs;
    },
  },
}
</script>
<style lang="">

</style>
